import { Component, Inject, inject, Injectable } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialogActions, MatDialogContent,
  MatDialogRef, MatDialogTitle,
} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

export interface ConfirmDialogData {
  title: string;
  message: string;
}

@Component({
  templateUrl: './confirm-dialog.component.html',
  standalone: true,
  imports: [
    TranslateModule,
    MatDialogActions,
    MatDialogTitle,
    MatDialogContent,
    MatButton,
  ],
})
export class ConfirmDialogComponent {
  public constructor(
    public readonly dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: ConfirmDialogData,
  ) {}

  public close(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}
